// Modules
import { Button, Radio, RadioChangeEvent, Input, Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { useEffect } from "react";

// styles
import styles from "components/molecules/Filters/filters.module.css";

// Constants
import { Filters as Constants } from "constants/global";

export type FilterItem = {
	value: string;
	label?: string;
	id: string;
	type?: "search" | "default";
	hasInput?: boolean;
	inputPlaceholder?: string;
	filterName?: string;
};

type FilterProps = {
	filters: Array<{
		title: string;
		values: Array<FilterItem>;
	}>;
	selectedFilers: Array<string | undefined>;
	onClick: ({ value, name, checked, isTextInput }: { name: string; value: string; checked: boolean; isTextInput?: boolean }) => void;
	onReset: () => void;
	onGlobalStateChange?: (filterType: string, value: string) => void;
	isGroupPendingClaims?: boolean;
};

const RetroClaimFilters = ({ filters, selectedFilers, onClick, onReset, onGlobalStateChange, isGroupPendingClaims }: FilterProps) => {
	useEffect(() => {
		if (isGroupPendingClaims) {
			filters
				.find((section) => section.title === "Filter by")
				?.values.slice(0, 2)
				.forEach((item) => {
					onClick({
						value: item.value,
						name: "Filter by",
						checked: true
					});
				});
		}
	}, [isGroupPendingClaims]);

	const handleReset = () => {
		// First clear all selections
		onReset();
	};

	const handleCheckboxChange = (e: CheckboxChangeEvent, title: string) => {
		const value = e.target.value;
		const isChecked = e.target.checked;
		onClick({
			value,
			name: title,
			checked: isChecked
		});
	};

	const handleRadioChange = (e: RadioChangeEvent) => {
		onClick({
			value: e.target.value,
			name: e.target.name || "",
			checked: e.target.checked
		});
	};

	const handleTextInputChange = (e: React.ChangeEvent<HTMLInputElement>, filterType: string) => {
		e.preventDefault();
		e.stopPropagation();

		onClick({
			value: e.target.value,
			name: filterType,
			checked: true,
			isTextInput: true
		});

		if (onGlobalStateChange) {
			onGlobalStateChange(filterType, e.target.value);
		}
	};

	return (
		<div className={styles?.root}>
			<div className={styles?.reset_wrapper}>
				<Button className={styles?.reset_button} onClick={handleReset}>
					{Constants.RESET_BUTTON_LABEL}
				</Button>
			</div>
			<div className={styles?.filters_wrapper}>
				{filters?.map(({ title, values }, idx) => {
					const isFilterBySection = title === "Filter by";
					const isSortBySection = title === "Sort by";
					let selectedValue;

					if (isSortBySection) {
						const len = values.length;
						for (let j = 0; j < len; j++) {
							if (selectedFilers.includes(values[j].value) || selectedFilers.includes(`${title}_sort_${values[j].value}`)) {
								selectedValue = values[j].value;
								break;
							}
						}
					}

					return (
						<div key={`${title}-${idx}`}>
							<div className={styles?.filter_header}>{title}</div>
							<div className={styles?.filter_items}>
								{isFilterBySection ? (
									<div>
										{values?.map((item, index) => (
											<div className={styles?.filter_item_checkbox} key={`${item.value}-${index}`}>
												<Checkbox id={item?.id} value={item.value} onChange={(e) => handleCheckboxChange(e, title)} checked={selectedFilers[0]?.split(",").includes(item.value)}>
													<span className={styles?.item_label}>{item?.label || item?.value}</span>
												</Checkbox>
												{item.hasInput && (
													<Input
														placeholder={item.inputPlaceholder}
														onChange={(e) => handleTextInputChange(e, item.filterName || "")}
														className={styles.filter_input}
														onClick={(e) => e.stopPropagation()}
													/>
												)}
											</div>
										))}
									</div>
								) : (
									<Radio.Group name={title} onChange={handleRadioChange} value={selectedValue}>
										{values?.map((item, index) => (
											<div className={styles?.filter_item} key={`${item.value}-${index}`}>
												<Radio id={item?.id} value={item.value} className="filter_radio">
													<span className={styles?.item_label}>{item?.label || item?.value}</span>
												</Radio>
											</div>
										))}
									</Radio.Group>
								)}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default RetroClaimFilters;
